import { LocalFormActionTypes } from "./form.types";

export const modifyLocalForm = (data) => (dispatch) => {
  return dispatch({
    type: LocalFormActionTypes.MODIFY_LOCAL_FORM,
    payload: data,
  });
};

export const resetLocalForm = (data) => (dispatch) => {
  dispatch({ type: LocalFormActionTypes.RESET_LOCAL_FORM });
};
